import { render, staticRenderFns } from "./Dzieci.vue?vue&type=template&id=cfc54cf2&scoped=true&"
import script from "./Dzieci.vue?vue&type=script&lang=js&"
export * from "./Dzieci.vue?vue&type=script&lang=js&"
import style0 from "./Dzieci.vue?vue&type=style&index=0&id=cfc54cf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc54cf2",
  null
  
)

export default component.exports